<template>
  <ResponsivePopoverView v-model:active="active" placement="bottom">
    <template v-slot:target>
      <ButtonView type="shaded" color="foreground" size="small" :active="active || editor.isActive('infoBox')" @click="active = true">
        <i class="fas fa-info-circle fa-fw" style="font-size: 1.2em"></i>
      </ButtonView>
    </template>
    <template v-slot:body>
      <div class="d-flex align-items-center g-2">
        <ButtonView type="soft" color="info" @click="editor.chain().focus().toggleInfoBox({ type: 'info' }).run(); active = false" :active="editor.isActive('infoBox', { type: 'info' })">
          <i class="fas fa-info-circle fa-fw"></i>
        </ButtonView>
        <ButtonView type="soft" color="success" @click="editor.chain().focus().toggleInfoBox({ type: 'success' }).run(); active = false" :active="editor.isActive('infoBox', { type: 'success' })">
          <i class="fas fa-check-circle fa-fw"></i>
        </ButtonView>
        <ButtonView type="soft" color="warning" @click="editor.chain().focus().toggleInfoBox({ type: 'warning' }).run(); active = false" :active="editor.isActive('infoBox', { type: 'warning' })">
          <i class="fas fa-exclamation-circle fa-fw"></i>
        </ButtonView>
        <ButtonView type="soft" color="danger" @click="editor.chain().focus().toggleInfoBox({ type: 'danger' }).run(); active = false" :active="editor.isActive('infoBox', { type: 'danger' })">
          <i class="fas fa-exclamation-triangle fa-fw"></i>
        </ButtonView>
      </div>
    </template>
  </ResponsivePopoverView>
</template>

<script setup>
import ResponsivePopoverView from "../../../general/ResponsivePopoverView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";

defineProps({
  editor: Object
});

const active = ref(false);

</script>